<button [attr.type]="type" class="btn" [ngStyle]="{ width: width }" [ngClass]="styleClass" [style]="style"
  [disabled]="disabled" (click)="onClick.emit($event)" (focus)="onFocus.emit($event)" (blur)="onBlur.emit($event)">
  <i [ngClass]="iconClass" class="btn-icon btn-left-icon" *ngIf="iconClass&&isLeft()"></i>
  <span class="btn-text">
  <ng-content></ng-content>
</span>
  <i [ngClass]="iconClass" class="btn-icon btn-right-icon" *ngIf="iconClass&&!isLeft()"></i>
</button>